import { PaymentMethodCode } from '@src/domains/payments';
import type { OrderPaymentSummary } from '@src/domains/orders';
import type { OrderPaymentDetails } from '@src/features/orders/details/types';
import type { DefaultMessagesKeys, Translate } from '@src/i18n/useTranslate';

const METHOD_LABEL_KEYS: Record<string, DefaultMessagesKeys> = {
  [PaymentMethodCode.CreditCard]: 'checkout_payment_method_credit_card',
  [PaymentMethodCode.DebitCard]: 'checkout_payment_method_debit_card',
  [PaymentMethodCode.Pix]: 'checkout_payment_method_pix',
  [PaymentMethodCode.PostPaid]: 'checkout_payment_method_post_paid',
};

export const toOrderPaymentDetails = (
  summary: OrderPaymentSummary | null,
  i18n: Translate['i18n'],
): OrderPaymentDetails | undefined => {
  if (!summary) {
    return undefined;
  }

  const labelKey = METHOD_LABEL_KEYS[summary.methodCode];

  return {
    methodLabel: labelKey ? i18n(labelKey) : summary.methodCode,
    brandCode: summary.brandCode,
    isPix: summary.methodCode === PaymentMethodCode.Pix,
    showsInstallments:
      summary.methodCode === PaymentMethodCode.CreditCard &&
      summary.installments >= 1 &&
      summary.installmentAmount != null,
    installments: summary.installments,
    installmentAmount: summary.installmentAmount,
  };
};
